import { useEffect } from "react";

export const useFreezeViewportScroll = ({ viewportRef, frozen }) => {
  useEffect(() => {
    const viewport = viewportRef.current;
    if (!viewport || !frozen) return undefined;
    const left = viewport.scrollLeft;
    const top = viewport.scrollTop;
    const onScroll = () => {
      if (viewport.scrollLeft === left && viewport.scrollTop === top) return;
      viewport.scrollLeft = left;
      viewport.scrollTop = top;
    };
    viewport.addEventListener("scroll", onScroll);
    return () => viewport.removeEventListener("scroll", onScroll);
  }, [frozen, viewportRef]);
};
